//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 07.12.2015.
 */

(function () {

    'use strict';

    angular.module('container.layout')
        .factory('headerService', headerService);

    function headerService($rootScope) {

        var service = {};

        var components = [];

        service.addComponent = function (id, markup, position) {

            if (position == null)
                position = components.length;

            var component = new Component(id, markup);
            components.splice(position, 0, component);

            notify();
        };

        service.removeComponent = function (id) {

            _.remove(components, function (component) {
                return component.id == id;
            });

            notify();
        };

        service.removeComponents = function () {

            components = [];

            notify();
        };

        service.getComponent = function (id) {
            return _.find(components, function (component) { return component.id == id; });
        };

        service.getComponents = function () {
            return components;
        };

        function notify() {
            $rootScope.$emit('headerService:componentsChanged');
        }

        return service;
    }

    function Component(id, markup) {
        this.id = id;
        this.markup = markup;
    }
})();